module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Auth'), _vm._v(" "), _c('Reg'), _vm._v(" "), _c('Applying'), _vm._v(" "), _c('Create'), _vm._v(" "), _c('Help'), _vm._v(" "), _c('Pay')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3926aaa0","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/modal.vue
// module id = 350
// module chunks = 2